module.exports = __webpack_public_path__ + "static/media/file-png.b13afd50.svg";